import axios from "axios";
import { setAuthHeader } from "app/services/auth.header.service";
import { getUrlForAllLeavePlansByDate } from "utils/endpointUtils/leavePlansEndpointUtil";
import { getUrlForAddActivityType, getUrlForAllActivityTypes, getUrlForDeleteActivityType, getUrlForUpdateActivityType } from "utils/endpointUtils/activitiesEndpointUtil";

export const loadLeavePlansFromBackendForAdmin = async (fromDate, toDate) => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForAllLeavePlansByDate(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadAllActivityTypes = async () => {
    const config = setAuthHeader();
    
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForAllActivityTypes();
    return await axios.get(url, config);
}

export const addActivityTypeToBackend = async (activityTypeObject) => {
    const config = setAuthHeader();

    if (config === null) throw new Error("Invalid Auth Header or Token Expired");
  
    const postUrl = getUrlForAddActivityType();
  
    return await axios.post(postUrl, activityTypeObject, config);
}

export const updateActivityTypeToBackend = async (id, activityTypeObject) => {
    const config = setAuthHeader();

    if (config === null) throw new Error("Invalid Auth Header or Token Expired");
  
    const updateUrl = getUrlForUpdateActivityType(id);
  
    return await axios.put(updateUrl, activityTypeObject, config);
}

export const deleteActivityType = async (id) => {
    const config = setAuthHeader();

    if (config === null) throw new Error("Invalid Auth Header or Token Expired");
  
    const deleteUrl = getUrlForDeleteActivityType(id);
  
    return await axios.delete(deleteUrl, config);
}


